import PopUp from "../../containers/PopUp";
import { NavLink } from "react-router-dom";

const PopAddress = ({ setShowStationPopUp, shippingAddress }) => {
  const trim = (value) => (value == null ? "" : String(value).trim());
  let addressText = "כתובת לא זמינה";

  if (shippingAddress && shippingAddress !== "כתובת לא נמצאה") {
    const recipient = trim(shippingAddress.addrOrderRecipientName);
    const lastName = trim(shippingAddress.lastName);
    const city = trim(shippingAddress.addrCity);
    const streetHouse = [
      trim(shippingAddress.addrStreet),
      trim(shippingAddress.addrHouse),
    ]
      .filter(Boolean)
      .join(" ");
    const apartment = trim(shippingAddress.addrApartment);

    addressText =
      [
        recipient || lastName || null,
        city || null,
        streetHouse ? `רחוב ${streetHouse}` : null,
        apartment ? `דירה ${apartment}` : null,
      ]
        .filter(Boolean)
        .join(", ") || "כתובת לא זמינה";
  }

  return (
    <PopUp
      close={() => setShowStationPopUp(false)}
      width="600px"
      wrapperClassName="popup-wrapper--address"
    >
      <div className="popAddress">
        <div className="titleAddress">הכתובת המעודכנת במערכת</div>
        <div className="userAddress">{addressText}</div>
        <div className="popAddress__actions">
          <button
            type="button"
            className="popAddress__btn popAddress__btn--primary"
            onClick={() => setShowStationPopUp(false)}
          >
            אישור
          </button>
          <NavLink to="/private-area/address">
            <button
              type="button"
              className="popAddress__btn popAddress__btn--secondary"
              onClick={() => setShowStationPopUp(false)}
            >
              עדכון כתובת
            </button>
          </NavLink>
        </div>
      </div>
    </PopUp>
  );
};

export default PopAddress;
